import { c as _c } from "react/compiler-runtime";
import { IcoChevronLeftBig16, IcoClose16 } from '@onefootprint/icons';
import { IconButton } from '@onefootprint/ui';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { resolveBuilderBackRoute } from '@/utils/agent-builder-route';
import { useBuilder } from '../store/provider';
type NavigationControlsProps = {
  onClose?: () => void;
};
const NavigationControls = t0 => {
  const $ = _c(19);
  const {
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "agentBuilder.canvas.header"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("agents", t1);
  const {
    flushPendingOps,
    state
  } = useBuilder();
  const router = useRouter();
  let t2;
  if ($[1] !== flushPendingOps || $[2] !== router) {
    t2 = async () => {
      await flushPendingOps();
      router.push(resolveBuilderBackRoute(router.query.from));
    };
    $[1] = flushPendingOps;
    $[2] = router;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleBack = t2;
  if (onClose) {
    let t3;
    if ($[4] !== t) {
      t3 = t(_temp);
      $[4] = t;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== onClose || $[7] !== t3) {
      t4 = <IconButton aria-label={t3} icon={IcoClose16} size="compact" variant="ghost" onClick={onClose} />;
      $[6] = onClose;
      $[7] = t3;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== state.bundle.name) {
      t5 = <span className="min-w-0 truncate text-label-2 text-primary">{state.bundle.name}</span>;
      $[9] = state.bundle.name;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    let t6;
    if ($[11] !== t4 || $[12] !== t5) {
      t6 = <div className="flex h-11 shrink-0 items-center gap-2 px-3">{t4}{t5}</div>;
      $[11] = t4;
      $[12] = t5;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    return t6;
  }
  let t3;
  if ($[14] !== t) {
    t3 = t(_temp2);
    $[14] = t;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  let t4;
  if ($[16] !== handleBack || $[17] !== t3) {
    t4 = <div className="flex h-11 shrink-0 items-center gap-2 px-3"><IconButton aria-label={t3} icon={IcoChevronLeftBig16} size="compact" variant="ghost" onClick={handleBack} /></div>;
    $[16] = handleBack;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  return t4;
};
export default NavigationControls;
function _temp($) {
  return $.toggleNav.close;
}
function _temp2($_0) {
  return $_0.back;
}